export default "__VITE_ASSET__D3lR7rOQ__"